import {call, put, takeLatest} from "redux-saga/effects";
import {API} from "../../../api/api";
import {historyAPI} from "../api/api";
import {HistoryActionTypes} from "../actions/actionTypes";
import _ from "lodash";

function* getActivityLogs(action) {
    try {
        const historyResponse = yield call(() =>
            historyAPI.getActivityLogs({
                skip: (action.payload.page - 1) * action.payload.top,
                top: action.payload.top,
                event: action.payload.event,
                users: action.payload.users,
                range: action.payload.range,
                entity_type: action.payload.entity_type,
                entity_id: action.payload.entity_id
            })
        );

        const users: number[] = historyResponse.data["results"].reduce(
            (accumulator, activity) => {
                if (activity.event_user && !accumulator.find(a =>a.id === activity.event_user.id)) {
                    accumulator.push(activity.event_user);
                }
                return accumulator;
            },
            []
        );

        yield put({
            type: HistoryActionTypes.GET_ACTIVITY_SUCCESS,
            payload: {
                games: historyResponse.data,
                users: {
                    results: users,
                    count: users.length
                }
            }
        });

    } catch (e) {
        API.handleError(e.response, "Error getting Activity Logs.");

        yield put({
            type: HistoryActionTypes.GET_ACTIVITY_FAIL,
            message: e.message
        });
    }
}

export function* getActivityLogsWatcher() {
    yield takeLatest(HistoryActionTypes.GET_ACTIVITY, getActivityLogs);
}
